import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ProfileFormDialogData {
    suiteUrl: string;
}

@Component({
    selector: 'app-profile-form-dialog',
    template: `
        <div class="profile-form-dialog">
            <app-profile-form
                [suiteUrl]="data.suiteUrl"
                (onClose)="close()">
            </app-profile-form>
        </div>
    `,
    standalone: false,
    styles: [`
        .profile-form-dialog {
            padding: 24px;
        }
    `],
})
export class ProfileFormDialog {
    constructor(
        private dialogRef: MatDialogRef<ProfileFormDialog>,
        @Inject(MAT_DIALOG_DATA) public data: ProfileFormDialogData,
    ) {}

    close(): void {
        this.dialogRef.close();
    }
}